import { Doms } from "../../../../components/doms";
import { LoadingDot } from "../../../../components/loading-dot";
import { ModalController } from "../../../../components/modal/controller";
import { UserPrivateAccountStorage } from "../storage";
import { UserPrivateAccountSubscriptionsModel } from "./model";
import { UserPrivateAccountSubscriptionsView } from "./view";
export const Plans = [
  {
    idcod: '451yzd8MoDEr565j7Nul',
    title: 'Gratuito',
    activePublications: 4,
    promotions: 0,
    banners: 0,
    segmentation: 0,
    optionText: 'Plan Gratuito (hasta 4 publicaciones, sin banners)'
  },
  {
    idcod: 'w8G9521rMzJH614G85h9',
    title: 'Básico',
    activePublications: 20,
    promotions: 1,
    banners: 0,
    segmentation: 1,
    optionText: 'Plan Básico (hasta 20 publicaciones, sin banners)'
  },
  {
    idcod: '4H9In472WmV6oAuXkZy5',
    title: 'Destacado',
    activePublications: 50,
    promotions: 1,
    banners: 1,
    segmentation: 1,
    optionText: 'Plan Destacado (hasta 50 publicaciones, 1 banner)'
  },
  {
    idcod: 'vz9P7597l7n7132v4895',
    title: 'Empresa',
    activePublications: 999999,
    promotions: 3,
    banners: 3,
    segmentation: 10,
    optionText: 'Plan Empresa (publicaciones ilimitadas, 3 banners, estrategia, diseño y redes)'
  },
];

export const Status = [
  { id: 1, text: 'pending', description: 'Falta definir el medio de pago o completar el primer cobro.' },
  { id: 2, text: 'authorized', description: 'Suscripción activa.' },
  { id: 3, text: 'paused', description: 'Suspendida temporalmente.' },
  { id: 4, text: 'cancelled', description: 'Suscripción finalizada.' }
]

export class UserPrivateAccountSubscriptionsController {
  static instance;

  constructor() {
    if (UserPrivateAccountSubscriptionsController.instance) {
      throw new Error('Clase singleton')
    }
    this.model = UserPrivateAccountSubscriptionsModel.getInstance();
    this.view = UserPrivateAccountSubscriptionsView.getInstance();
    this.confirmationModal = null;
    this.storage = UserPrivateAccountStorage.getInstance();
    this.doms = new Doms();
  }

  static getInstance() {
    if (!UserPrivateAccountSubscriptionsController.instance) {
      UserPrivateAccountSubscriptionsController.instance = new UserPrivateAccountSubscriptionsController();
    }
    return UserPrivateAccountSubscriptionsController.instance;
  }

  async getStatus() {
    // Si es la primera navegacion despues del login, fuerza la recarga desde mercadopago. 
    if (!window.localStorage.getItem('user-plan')) {
      await this.model.getMPStatus();
    }
    return this.model.getStatus();
  }

  getObjectPlanByIdcod(_idcod) {
    return Plans.find(i => i.idcod == _idcod) || Plans[0];
  }

  getObjectStatusById(_id) {
    return Status.find(i => i.id == _id) || Status[0];
  }

  changePlan(_idcod) {
    return this.model.changePlan(_idcod);
  }

  showPlanStatus() {
    this.modalPlan = new ModalController('Actualización de tu plan', this.view.renderBackMP(), 'plan-change');
    this.modalPlan.show();
  }

  async showChangePlan(_title) {
    let plan = this.storage.planRead();
    let planActiveObj = this.getObjectPlanByIdcod(plan.planActiveIdcod);
    let planObj = this.getObjectPlanByIdcod(plan.planIdcod);
    let status = this.getObjectStatusById(plan.statusId);
    let statusActive = this.getObjectStatusById(plan.statusActiveId);

    this.modalPlan = new ModalController((_title || 'Editar mi plan'), LoadingDot.render(), 'plan-change');
    this.modalPlan.show();
    this.view.renderChangePlanWindow(planObj, status, statusActive, planActiveObj, plan)
      .then((html) => {
        this.modalPlan.setContent(html);
        let plans = Plans.filter(i => i.idcod != planActiveObj.idcod);
        if (plan.statusId == '4') {
          plans = Plans;
        }
        plans = plans.map((i) => {
          return { value: i.idcod, text: i.optionText };
        });

        APICRUD.Common.Select.SetData('new-plan', plan.idcod, plans);
      })
      .catch((e) => {
        this.modalPlan.setContent(e)
      })

  }

  closeConfirmationModal() {
    if (this.confirmationModal && this.confirmationModal.close) {
      this.confirmationModal.close();
    }
  }

  // CHANGE
  changePlan() {
    let newPlan = this.doms.getValue('new-plan');
    let planObj = this.getObjectPlanByIdcod(newPlan);
    this.confirmationModal = new ModalController('Editar mi plan', this.view.renderChangePlanConfirmation(planObj));
    this.confirmationModal.show();
  }

  changePlanConfirmation(_newPlan) {
    // this.confirmationModal.close();
    this.model.changePlan(_newPlan)
      .then((data) => {
        // DONE: debe recibir el link de la nueva suscripcion
        console.log(data)
        if (data.status != 'OK') {
          console.log(data);
          this.doms.setHTML('new-plan-status', data.message);
          this.doms.addClass('new-plan-status', 'mt20');
        } else {
          window.location.href = data.url;
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  // CANCEL 
  cancelPlan() {
    let plan = this.storage.planRead();
    let planActiveObj = this.getObjectPlanByIdcod(plan.planActiveIdcod);
    this.confirmationModal = new ModalController('Cancelar plan', this.view.renderCancelPlanWindow(planActiveObj), 'plan-change');
    this.confirmationModal.show();
  }

  cancelPlanConfirmation() {
    this.model.cancelPlan()
      .then((data) => {
        console.log(data)
        if (data.status == 'KO') {
          this.doms.setHTML('cancel-plan-status', data.message);
        }
      })
      .catch((err) => {
        console.log(err)
        this.confirmationModal.close();
      })
      .finally(() => {
        this.storage.clear();
        window.location.reload();
      })
  }
}
